import { render, staticRenderFns } from "./otelyolcumnerede.vue?vue&type=template&id=5e6dbaa3&"
import script from "./otelyolcumnerede.vue?vue&type=script&lang=js&"
export * from "./otelyolcumnerede.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports